import styled from "styled-components"
import {ButtonRouterLink} from "@irati/ui/src/Link"

export default styled(ButtonRouterLink)`
  margin-top: 60px;
  display: inline-block;
`
